import {ChangeDetectionStrategy, Component, Input} from '@angular/core'
import {WaveCoverImageModule} from '../wave-cover-image/wave-cover-image.module'

@Component({
  selector: 'cft-hero-cover',
  standalone: true,
  templateUrl: './hero-cover.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [
    `
      :host {
        @apply block;
      }
    `,
  ],
  imports: [WaveCoverImageModule],
})
export class HeroCoverComponent {
  @Input() showBreadcrumbs = false
}
